import { IconProps } from "typing";
import { theme } from "../themes";

export const MyListsIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49902 5.36392H16.6695"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6695 10H7.49902"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49902 14.6361H16.6695"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74741 4.94708C3.51719 4.94708 3.33057 5.13371 3.33057 5.36392C3.33057 5.59414 3.51719 5.78076 3.74741 5.78076C3.97762 5.78076 4.16425 5.59414 4.16425 5.36392C4.16425 5.13371 3.97762 4.94708 3.74741 4.94708"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74741 9.58319C3.51719 9.58319 3.33057 9.76982 3.33057 10C3.33057 10.2302 3.51719 10.4169 3.74741 10.4169C3.97762 10.4169 4.16425 10.2302 4.16425 10C4.16425 9.76982 3.97762 9.58319 3.74741 9.58319"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74741 14.2193C3.51719 14.2193 3.33057 14.4059 3.33057 14.6361C3.33057 14.8664 3.51719 15.053 3.74741 15.053C3.97762 15.053 4.16425 14.8664 4.16425 14.6361C4.16425 14.4059 3.97762 14.2193 3.74741 14.2193"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
